// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"MethodOption_icon-wrapper__Y4n3E"};